import Vue from 'vue';
import Router from 'vue-router';

Vue.use( Router );

let appRouter = new Router({
    mode: 'history',
    routes: [
        // generated-routes
        {
            path: '/',
            name: 'Landing',
            component: () =>
            {
                return import( /* webpackChunkName: "landing" */ '@/app/pages/Landing' );
            }
        },
        {
            path: '/teaser',
            name: 'Teaser',
            component: () =>
            {
                return import( /* webpackChunkName: "teaser" */ '@/app/pages/Teaser' );
            }
        },
        {
            path: '/list',
            name: 'List',
            component: () =>
            {
                return import( /* webpackChunkName: "list" */ '@/app/pages/List' );
            }
        },
        {
            path: '/story/:id',
            name: 'Story',
            component: () =>
            {
                return import( /* webpackChunkName: "story" */ '@/app/pages/Story' );
            }
        }
    ]
});

appRouter.beforeEach( ( to, from, next ) =>
{
    if( typeof to.beforeEnter === 'function' ) // check if the route has a beforeEnter function
    {
        to.beforeEnter( to, from, next );
        return;
    }

    next();
});

export default appRouter;
